import api from '@/configurations/service';
import * as types from './mutation-types';

export const resetOsObjectsState = async (context) => {
  context.commit(types.RESET_OS_OBJECT);
};

export const setSummaryOsObjects = async (context, { search, pagination }) => {
  const body = { search, pagination };
  const { data } = await api().post('consumers.find-summary-service-order-objects', body);

  context.commit(types.SET_SUMMARY_OS_OBJECTS, data.data);
  context.commit(types.SET_PAGINATION_OS_OBJECTS, data.pagination);
};

export const saveOsObject = async (_, payload) => {
  const { id } = payload;

  if (!id) {
    await api().post('consumers.register-service-order-object', payload);
    return;
  }

  await api().post('consumers.update-service-order-object', payload);
};

export const deleteOsObjects = async (_, ids) => {
  const { data } = await api().post('consumers.delete-service-order-objects', { ids });

  return data;
};

export const setDetailedOsObject = async (context, id) => {
  const { data } = await api().post('consumers.find-service-order-object', { id });

  context.commit(types.SET_DETAILED_OS_OBJECT, data);
};
